module.exports = __webpack_public_path__ + "img/questionmark-icon.3daab698.svg";